const avatarRounded = (avatar, name = '', width = 80, height = 80) => {
  // Normalize name by removing extra spaces and trimming
  const normalizedName = name.replace(/\s+/g, ' ').trim();

  const initialName = getInitials(normalizedName);
  const randomColor = defaultAvatarColors[(Math.floor(Math.random() * defaultAvatarColors.length))];
  const photo = avatar ? `<img class="rounded" src="${avatar}" width="${width}" height="${height}" />` : `<div class="initial-name d-flex align-items-center justify-content-center fs-1 tourney ${randomColor} text-uppercase" style="width: ${width}px; height: ${height}px;">${initialName}</div>`;

  return photo;
}

const getInitials = (name) => {
  const words = name.split(' ');
  if (words.length === 1) {
    return words[0][0].toUpperCase();
  } else if (words.length >= 2) {
    return `${words[0][0]}${words[1][0]}`.toUpperCase();
  }
  return '';
}

export default avatarRounded;


